import { Routes } from '@angular/router';
import { AuthenticationRoute } from './authentication.route';
import { RouteSubComponent } from 'authorization';
import { groupsRouting } from './feature/groups/groups.routing';
import { RouteLazyComponent } from 'authorization';
import { InjectionToken } from '@angular/core';
import { Environment } from 'src/setting';
import { GoToPreviousService } from 'previous-url';
const ENVIRONMENT = new InjectionToken<Environment>('environment');
export const AuthenticationRouting: Routes = [
  {
    path: 'full',
    loadComponent: () =>
      import('app/component/full-layout/full-layout.component').then(
        (c) => c.FullLayoutComponent,
      ),
    data: {
      breadcrumb: {
        skip: true,
      },
      title: '',
    },
    children: [
      {
        path: 'login',
        pathMatch: 'full',
      },
      {
        path: 'authentication',
        loadComponent: () =>
          import('./app/component/auth/app-auth.component').then(
            (c) => c.AuthComponent,
          ),
        providers: [GoToPreviousService],
        data: {
          breadcrumb: {
            skip: true,
          },
          title: '',
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './app/component/auth-management/auth-management.component'
              ).then((m) => m.AuthManagementComponent),
          } as RouteSubComponent<
            typeof AuthenticationRoute.map.full.authentication,
            'root'
          >,
          {
            path: 'forget_password',
            loadComponent: () =>
              import(
                './app/component/forget-password/app-forget-password.component'
              ).then((c) => c.AppForgetPasswordComponent),
          } as RouteSubComponent<
            typeof AuthenticationRoute.map.full.authentication,
            'forget_password'
          >,
        ],
      } as RouteLazyComponent<
        typeof AuthenticationRoute.map.full,
        'authentication'
      >,
    ],
  } as RouteLazyComponent<typeof AuthenticationRoute.map, 'full'>,
  {
    path: 'dashboard',
    loadComponent: () =>
      import(
        'src/domains/theme/app/component/full-layout/full-layout.component'
      ).then((m) => m.FullLayoutComponent),
    data: {
      breadcrumb: {
        skip: true,
      },
    },
    children: [
      {
        path: '',
        redirectTo: 'status_summary',
        pathMatch: 'full',
      },
      {
        path: 'new_profile',
        loadComponent: () =>
          import(
            './app/component/app-complete-profile/app-complete-profile.component'
          ).then((m) => m.AppCompleteProfileComponent),
        providers: [GoToPreviousService],
        data: {
          breadcrumb: {
            label: 'احراز هویت',
            parent: ['پروفایل'],
            parentUrl: [AuthenticationRoute.map.dashboard.company_list],
          },
          title: '',
        },
      } as RouteSubComponent<
        typeof AuthenticationRoute.map.dashboard,
        'new_profile'
      >,
      {
        path: 'authentication',
        loadComponent: () =>
          import('./app/component/app-profile/app-profile.component').then(
            (m) => m.AppProfileComponents,
          ),
        data: {
          breadcrumb: {
            label: 'احراز هویت',
            parent: ['پروفایل'],
            parentUrl: [AuthenticationRoute.map.dashboard.company_list],
          },
          title: '',
        },
      } as RouteSubComponent<
        typeof AuthenticationRoute.map.dashboard,
        'authentication'
      >,
      {
        path: 'create_company',
        loadComponent: () =>
          import(
            './app/component/create-company/create-company.component'
          ).then((m) => m.CreateCompanyComponent),
        data: {
          breadcrumb: {
            label: 'ایجاد سازنده',
            parent: ['مدیریت سازنده'],
            parentUrl: [AuthenticationRoute.map.dashboard.company_list],
          },
          title: '',
        },
      } as RouteSubComponent<
        typeof AuthenticationRoute.map.dashboard,
        'create_company'
      >,
      {
        path: 'company_list',
        loadComponent: () =>
          import('./app/component/company-list/company-list.component').then(
            (m) => m.CompanyListComponent,
          ),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<
        typeof AuthenticationRoute.map.dashboard,
        'company_list'
      >,
      {
        path: 'edit_user',
        loadComponent: () =>
          import('./app/component/edit-user/app-edit-user.component').then(
            (m) => m.AppEditUserComponent,
          ),
        data: {
          breadcrumb: {
            label: 'ویرایش پروفایل',
            parent: ['پروفایل'],
            parentUrl: [AuthenticationRoute.map.dashboard.profile],
          },
          title: '',
        },
      } as RouteSubComponent<
        typeof AuthenticationRoute.map.dashboard,
        'edit_user'
      >,
      {
        path: 'edit_company',
        loadComponent: () =>
          import('./app/component/edit-company/edit-company.component').then(
            (m) => m.EditCompanyComponent,
          ),
        data: {
          breadcrumb: {
            label: 'ویرایش اطلاعات سازنده',
            parent: ['مدیریت سازنده ها'],
            parentUrl: [AuthenticationRoute.map.dashboard.company_list],
          },
          title: '',
        },
      } as RouteSubComponent<
        typeof AuthenticationRoute.map.dashboard,
        'edit_company'
      >,
      {
        path: 'notifications',
        loadComponent: () =>
          import(
            './app/component/app-client-notification/app-client-notification.component'
          ).then((m) => m.AppClientNotificationComponent),
      } as RouteSubComponent<
        typeof AuthenticationRoute.map.dashboard,
        'notifications'
      >,
      {
        path: 'create_user',
       loadComponent: () =>
        import(
          './app/component/create-user/create-user.component'
        ) .then((c) => c.CreateUserComponent)
      } as RouteSubComponent<
        typeof AuthenticationRoute.map.dashboard,
        'create_user'
      >,
      {
        path: 'user_managment',
        loadComponent: () =>
          import(
            './app/component/user-management/user-management.component'
          ).then((m) => m.UserManagementComponent),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<
        typeof AuthenticationRoute.map.dashboard,
        'user_managment'
      >,
    ],
  } as RouteLazyComponent<typeof AuthenticationRoute.map, 'dashboard'>,
  {
    path: 'groups',
    children: [...groupsRouting],
  } as RouteLazyComponent<typeof AuthenticationRoute.map, 'groups'>,
];
